import React, { useEffect, useState } from 'react'
import { Card } from 'reactstrap'
import { AnalysisRequestLastUpdate } from '../../../components/Common/AnalysisRequestLastUpdate'
import { AnalysisRequestNewRegisterButton } from '../../../components/Common/AnalysisRequestNewRegisterButton'
import { AnalysisRequestSaveButton } from '../../../components/Common/AnalysisRequestSaveButton'
import Table1 from "../../../components/Common/TableContainer"
import { TableItemDeleteModal } from '../../../components/Common/TableItemDeleteModal'
import { AssignUserModal } from './AssignUserModal'
import { NotifyAssignmentsModal } from './NotifyAssignmentsModal'
import moment from 'moment'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { addNewLabRequestAssignment, addNewNotificationManager, addNewNotificationResponsible, deleteLabRequestAssignment, getLabRequest, getLabRequestAssignments, getNotificationManagers, updateLabRequestAssignment } from '../../../store/actions'
import { postApiCall } from '../../../services/mainServices'
import { userRoles } from '../../../shared'
import { BaseCustomButton } from '../../../shared'
import { statuses } from '../../../constants'

export const AssignmentsTab = ({ props, id, labRequest, updateAssignmentStatus, generalStatus }) => {

    const role = (localStorage.getItem("authUser")) ? JSON.parse(localStorage.getItem("authUser"))?.role : ''
    const obj = JSON.parse(localStorage.getItem("authUser"));

    // * Redux
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getLabRequestAssignments(`?limit=20&page=&labRequest=${id}`));
        dispatch(getNotificationManagers(`?limit=20&page=0&labRequest=${id}`));
        dispatch(getLabRequest(`/${id}`));
    }, [dispatch, id])

    const { labRequestAssignments, loading, total, currentPage } = useSelector(state => ({
        labRequestAssignments: state.labRequestAssignmentReducer.labRequestAssignments,
        loading: state.labRequestAssignmentReducer.loading,
        total: state.labRequestAssignmentReducer.total,
        currentPage: state.labRequestAssignmentReducer.currentPage,
    }), shallowEqual);
    // * Redux fin

    useEffect(() => {
        const trackingObj = labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Asignar usuarios')
        if(trackingObj){
            updateAssignmentStatus(
                {
                    id: (labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Asignar usuarios')?.id)
                }
            );
            dispatch(getLabRequest(`/${id}`));
        }

    }, [labRequestAssignments])

    // Modal para Asignar Usuarios
    const [showModal1, setShowModal1] = useState(false);
    // Modal de borrar un Usuario
    const [showModal2, setShowModal2] = useState(false);
    // Modal de notificar a un usuario
    const [showModal3, setShowModal3] = useState(false);
    // Para la información de cada renglón
    const [rowInfo, setRowInfo] = useState();
    //New - local register of rows whose select changed
    const [pendingMap, setPendingMap] = useState({});


     const modalRespInfo = async (values) => {
        try {
          await dispatch(updateLabRequestAssignment({
            id: rowInfo.id,
            statusAssignment: rowInfo.statusAssignment,
            notify: false
          })).unwrap?.();
      
          const postObj = {
            ...values,
            labRequest: id,
            userNotifier: obj.id,
            datedAt: moment().format('YYYY-MM-DD'),
            validateProcess: rowInfo.statusAssignment,
            validationStatus: 'Aceptado',
            notificationResponsibles: [rowInfo.user.id],
          };
      
          const resp = await postApiCall('notification-managers', postObj);
      
          await dispatch(addNewNotificationResponsible({
            notificationManager: resp.data.id,
            userResponsible: rowInfo.user.id
          })).unwrap?.();
        } catch (err) {
          console.error('Error al notificar:', err);
        } finally {
          //Close modal and clear state ALWAYS
          setShowModal3(false);
          setRowInfo(null);
        }
      };

    // New - send emails to all users in pendingMap
    const sendMassEmails = async () => {
        await Promise.all(
            Object.entries(pendingMap).map(([id, { status }]) =>
                dispatch(updateLabRequestAssignment({
                id,
                statusAssignment: status  //wihout notify: false, backend does not send email
                }))
            )
        );
    
        //Clean pendingMap to avoid duplicates
        setPendingMap({});
    };

    const onDelete = (values) => {
        setRowInfo(values);
        setShowModal2(true);
    }

    const onDeleteConfirmation = () => {
        dispatch(deleteLabRequestAssignment(rowInfo));
        setRowInfo('');
    }

    const onNotifyAssignments = (values) => {
        setRowInfo(values);
        setShowModal3(true);
    }

    // New version: save in pendingMap and do silent PATCH
    const onNewValueSelect = React.useCallback((event, originalRow) => {
        const newStatus = event.target.value;
    
        // 1) Save in pendingMap (local state)
        setPendingMap(prev => ({
        ...prev,
        [originalRow.id]: { status: newStatus }
        }));
    
        // 2) PATCH with notify:false (silent)
        dispatch(updateLabRequestAssignment({
        id: originalRow.id,
        statusAssignment: newStatus,
        notify: false
        }));
    }, [dispatch]);

    const getPagination = (params) => {
        dispatch(getLabRequestAssignments(`${params}&labRequest=${id}`));
    }

    const addPropertyLabRequestTest = (rowIdSelected) => {
        return {
            labRequest: id,
            user: rowIdSelected?.id,
            laboratoryType: rowIdSelected?.laboratoryType?.id,
            location: rowIdSelected?.location?.id,
            statusAssignment: 'Pruebas de Laboratorio',
        }
    }

    const RegisterModalRespInfo = (rowsIdSelected) => {

        Promise.all(
            rowsIdSelected.map((rowIdSelected, index) => 
            setTimeout(() =>
            dispatch(addNewLabRequestAssignment(addPropertyLabRequestTest(rowIdSelected)))
            , 500 * index))
        )
    }

    const columns = React.useMemo(
        () => [
            {
                Header: 'Nombre de usuario',
                width: '25%',
                Cell: ({ row }) => (
                    <div>
                        <div className='text-left'>
                            {row.original.user ? `${row.original.user.name ?? ''} ${row.original.user.surname ?? ''}`.trim() || '-' : '-'}
                        </div>
                    </div>
                ),
            },
            {
                Header: 'Tipo de Laboratorio',
                width: '15%',
                Cell: ({ row }) => (
                    <div>
                        <div className='text-left'>{row.original.laboratoryType.name ?? '-'}</div>
                    </div>
                ),
            },
            {
                Header: 'Sede',
                width: '15%',
                Cell: ({ row }) => (
                    <div>
                        <div className='text-left'>{row.original.location.name ?? '-'}</div>
                    </div>
                ),
            },
            {
                Header: 'Asignaciones',
                width: '25%',
                Cell: ({ row }) => (
                    <div className='d-flex justify-content-center mb-1'>
                        <select
                            disabled={generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED}
                            className="form-select text-primary rounded-3 w-75"
                            value={
                                (pendingMap[row.original.id]?.status || row.original.statusAssignment)?.toLowerCase() === 'validación de informes'
                                    ? 'Validación de Informes'
                                    : (pendingMap[row.original.id]?.status || row.original.statusAssignment)?.toLowerCase() === 'validación de muestras'
                                    ? 'Validación de muestras'
                                    : (pendingMap[row.original.id]?.status || row.original.statusAssignment)
                            }
                            aria-label="Default select example"
                            onChange={(event) => { onNewValueSelect(event, row.original) }}
                        >
                            <option value="Pruebas de Laboratorio">Pruebas de Laboratorio</option>
                            <option value="Validación de Informes">Validación de Informes</option>
                            <option value="Validación de muestras">Validación de muestras</option>
                        </select>
                    </div>
                ),
            },
            {
                width: '20%',
                Header: "Acciones",
                Cell: ({ row }) => (
                    <div className="d-flex align-items-center justify-content-center gap-2">
                        <BaseCustomButton
                            color="primary"
                            label="Notificar"
                            outline
                            className="p-1 px-2"
                            icon="mdi-email-outline mdi-18px"
                            onClick={() => onNotifyAssignments(row.original)}
                            disabled={(role === userRoles.laboratorist || role === userRoles.technicalAdvisor) || generalStatus != null}
                        />
                        <BaseCustomButton
                            color="danger"
                            label="Eliminar"
                            outline
                            className="p-1 px-2"
                            icon="mdi-delete mdi-18px"
                            onClick={() => onDelete(row.original)}
                            disabled={(role === userRoles.laboratorist || role === userRoles.technicalAdvisor) || generalStatus != null}
                        />
                    </div>
                ),
            },
        ],
        [role, generalStatus, onNewValueSelect]
    )

    const data = [
        {
            userName: 'NMX',
            labType: 'SGI-CITEC',
            location: 'MUESTREO DE AGREGADOS',
            assignments: 'PENDIENTE',
        },
    ]

    return (
        <>
            <h5 className='text-left text-primary px-1'>Asignar Usuarios</h5>

            <Card className='rounded-3' style={{ padding: 20 }}>

                <h6 className='text-left text-success'>Información de seguimiento</h6>

                <div className='d-flex align-items-center justify-content-between pt-0'>
                    <div>
                        <AnalysisRequestLastUpdate client={`${labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Asignar usuarios')?.updatedBy?.name ?? ''} ${labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Asignar usuarios')?.updatedBy?.surname ?? ''}`}
                            date={`${moment(labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Asignar usuarios')?.updatedAt).format('YYYY-MM-DD HH:mm') ?? ''}`} />
                    </div>
                    <div className="d-flex gap-2">
                        <AnalysisRequestNewRegisterButton disabled={(role === userRoles.laboratorist || role === userRoles.technicalAdvisor) || generalStatus != null} showModal={showModal1} setShowModal={setShowModal1} text={'Asignar usuarios'} />
                        <BaseCustomButton
                            color="success"
                            label="Notificar"
                            icon="mdi-email-multiple-outline mdi-18px"
                            outline
                            disabled={Object.keys(pendingMap).length === 0}
                            onClick={sendMassEmails}
                        />
                    </div>
                </div>
                {
                    (showModal1)
                        ? <AssignUserModal props={props} showModal={showModal1} setShowModal={setShowModal1} modalRespInfo={RegisterModalRespInfo} />
                        : null
                }

                <Table1 currentPage={currentPage} getPagination={getPagination} total={total} loading={loading} isAddTableBorderStrap columns={columns} data={labRequestAssignments} />
                <NotifyAssignmentsModal props={props} showModal={showModal3} setShowModal={setShowModal3} modalRespInfo={modalRespInfo} rowInfo={rowInfo} />
                <TableItemDeleteModal onDeleteConfirmation={onDeleteConfirmation} props={props} showModal={showModal2} setShowModal={setShowModal2} modalHeader='Eliminar Usuarios' modalBodyLabel='¿Esta seguro que desea eliminar el usuario seleccionado?' />

            </Card>
        </>
    )
}
